import { render, staticRenderFns } from "./FormLocationMapping.vue?vue&type=template&id=92024b5a&scoped=true&"
import script from "./FormLocationMapping.vue?vue&type=script&lang=js&"
export * from "./FormLocationMapping.vue?vue&type=script&lang=js&"
import style0 from "./FormLocationMapping.vue?vue&type=style&index=0&id=92024b5a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92024b5a",
  null
  
)

export default component.exports